import { gqlCountryEnum as COUNTRY } from '@minecraft.graphql-types';

export const COUNTRIES_WITH_IMPERIAL_UNITS = [COUNTRY.US, COUNTRY.CA, COUNTRY.PR];

export const COUNTRIES_WITH_METRIC_UNITS = [
  COUNTRY.AU,
  COUNTRY.GB,
  COUNTRY.KR,
  COUNTRY.SG,
  COUNTRY.MX,
  COUNTRY.FR,
  COUNTRY.IN,
  COUNTRY.IE,
  COUNTRY.DE,
  COUNTRY.NL,
  COUNTRY.ES,
  COUNTRY.SE,
];
